export default {
  meta: {
    title: '单店详情',
    url: '/intelligent/storemobile',
    urlName: '智能运营'
  }
};
